import React, { useEffect, useState } from 'react';

import { useNiceCertification } from '@/shared/components/niceCertification/hooks/useNiceCertification';
import { useLocation, useNavigate } from 'react-router-dom';
import styled from 'styled-components';

const Container = styled.div`
  width: 100%;
  font-size: 1.6rem;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100dvh;
`;

const Inner = styled.div``;

const Title = styled.h1`
  margin-bottom: 6rem;
  font-size: 2.6rem;
  font-weight: bold;
  position: relative;
  /* top: -36px; */
  text-align: center;
  @media screen and (max-width: 640px) {
    font-size: 2rem;
    margin-bottom: 2.2rem;
    font-weight: 600;
  }
`;
const SubTitle = styled.h3`
  display: none;
  font-size: 1.2rem;
  color: ${(props) => props.theme.colors.txt200};
  line-height: normal;
  font-weight: 500;
  text-align: center;
  margin-bottom: 7rem;
  @media screen and (max-width: 640px) {
    display: block;
  }
`;

const CardWrap = styled.div`
  margin: 0 auto 4vw;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;

  .iconLogin {
    filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.06));
    margin-bottom: 10rem;
  }
  .iconID {
  }
  .iconPW {
  }
  @media screen and (max-width: 1080px) {
    .iconLogin {
      margin-bottom: 8rem;
    }
  }
  @media screen and (max-width: 640px) {
    width: 90%;
    max-width: 34rem;
    .iconLogin {
      margin-bottom: 0;
      width: 31px;
      height: 31px;
      margin-right: 3rem;
      svg {
        width: 100%;
        height: 100%;
      }
    }
  }
`;

const FindIdCard = styled.div`
  width: 34rem;
  background: #fff;
  margin-right: 2rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
  padding: 7.5rem 3rem 3.5rem;
  border-radius: 2rem;
  transition: all 0.1s ease;
  text-align: center;
  box-shadow: 0px 3px 10px 0px rgba(0, 0, 0, 0.07);
  border: 2px solid transparent;
  &:hover {
    border-color: #adc1f4;
    box-shadow: unset;
    transform: translateY(-20px);
    background-color: #fff;
  }
  cursor: pointer;
  @media screen and (max-width: 1080px) {
    width: 26rem;
  }
  @media screen and (max-width: 640px) {
    flex-direction: unset;
    border-radius: 1rem;
    width: 100%;
    padding: 1rem 2rem;
    flex-wrap: wrap;
    min-height: 6rem;
    &:hover {
      transform: none;
    }
    margin-right: 0rem;
    margin-bottom: 2rem;
  }
`;

const FindPwCard = styled.div`
  width: 34rem;
  background: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
  padding: 7.5rem 3rem 3.5rem;
  border-radius: 2rem;
  transition: all 0.1s ease;
  text-align: center;
  box-shadow: 0px 3px 10px 0px rgba(0, 0, 0, 0.07);
  border: 2px solid transparent;
  &:hover {
    border-color: #adc1f4;
    box-shadow: unset;
    transform: translateY(-20px);
    background-color: #fff;
  }
  cursor: pointer;
  @media screen and (max-width: 1080px) {
    width: 26rem;
  }
  @media screen and (max-width: 640px) {
    flex-direction: unset;
    border-radius: 1rem;
    width: 100%;
    padding: 1rem 2rem;
    flex-wrap: wrap;
    min-height: 6rem;
    &:hover {
      transform: none;
    }
  }
`;

const FindAccountName = styled.h1`
  font-size: 2.6rem;
  font-weight: 700;
  margin-bottom: 11rem;
  color: #191919;
  @media screen and (max-width: 1080px) {
    font-size: 2rem;
    margin-bottom: 5rem;
  }
  @media screen and (max-width: 640px) {
    margin-bottom: 0;
    font-size: 1.5rem;
  }
`;

const FindAccountDocs = styled.p`
  font-size: 1.4rem;
  line-height: 1.2;
  color: #191919;
  @media screen and (max-width: 1080px) {
    font-size: 1.2rem;
  }
  @media screen and (max-width: 640px) {
    display: none;
  }
`;

const MobileFindAccount = () => {
  const [popupData, setPopupData] = useState(null);
  const { niceCertification } = useNiceCertification();
  const navigate = useNavigate();

  const location = useLocation();
  const sEncodeData = location.state?.sEncodeData;

  useEffect(() => {
    if (sEncodeData) {
      setPopupData(sEncodeData);
    }
  }, [sEncodeData]);

  const handleFindIdClick = async () => {
    await niceCertification();
  };
  const isFindIdhanlder = async () => {
    try {
      if (popupData !== null) {
        const encData = {
          encodeData: popupData,
        };

        navigate('/mobile/mobileFindAccountList', {
          state: encData,
        });

        return null;
      }
    } catch (error) {
      return error;
    }
    return null;
  };

  // 팝업에서 보내온 메시지를 받는 이벤트 리스너
  const messageListener = (event: any) => {
    if (event.data.sEncodeData) {
      setPopupData(event.data.sEncodeData);
    }
  };

  useEffect(() => {
    // message 이벤트 리스너를 등록
    window.addEventListener('message', messageListener);

    // 컴포넌트가 언마운트될 때 이벤트 리스너를 제거
    return () => {
      window.removeEventListener('message', messageListener);
    };
  }, []);

  useEffect(() => {
    if (popupData) {
      isFindIdhanlder();
    }
  }, [popupData]);
  return (
    <Container>
      <Inner>
        <Title>서울이동통신 계정찾기</Title>
        <SubTitle>
          가입 시 등록한 본인 명의 휴대폰으로
          <br />
          계정찾기가 가능합니다.
        </SubTitle>
        <CardWrap>
          <FindIdCard onClick={handleFindIdClick}>
            <p className="iconLogin iconID">
              <svg xmlns="http://www.w3.org/2000/svg" width="129" height="123" viewBox="0 0 129 123" fill="none">
                <path
                  d="M51.1795 47.1795C44.6923 47.1795 39.1389 44.8697 34.5192 40.25C29.8996 35.6303 27.5897 30.0769 27.5897 23.5897C27.5897 17.1026 29.8996 11.5491 34.5192 6.92949C39.1389 2.30983 44.6923 0 51.1795 0C57.6667 0 63.2201 2.30983 67.8397 6.92949C72.4594 11.5491 74.7692 17.1026 74.7692 23.5897C74.7692 30.0769 72.4594 35.6303 67.8397 40.25C63.2201 44.8697 57.6667 47.1795 51.1795 47.1795ZM116.641 115L97.7692 96.1282C95.7051 97.3077 93.4936 98.2906 91.1346 99.0769C88.7756 99.8632 86.2692 100.256 83.6154 100.256C76.2436 100.256 69.9785 97.6773 64.8203 92.519C59.662 87.3607 57.0809 81.0937 57.0769 73.7179C57.0769 66.3462 59.658 60.0811 64.8203 54.9228C69.9825 49.7645 76.2475 47.1834 83.6154 47.1795C90.9872 47.1795 97.2542 49.7606 102.416 54.9228C107.579 60.085 110.158 66.3501 110.154 73.7179C110.154 76.3718 109.761 78.8782 108.974 81.2372C108.188 83.5961 107.205 85.8077 106.026 87.8718L124.897 106.744L116.641 115ZM83.6154 88.4615C87.7436 88.4615 91.2329 87.0363 94.0833 84.1859C96.9338 81.3355 98.359 77.8462 98.359 73.7179C98.359 69.5897 96.9338 66.1004 94.0833 63.25C91.2329 60.3996 87.7436 58.9744 83.6154 58.9744C79.4872 58.9744 75.9979 60.3996 73.1474 63.25C70.297 66.1004 68.8718 69.5897 68.8718 73.7179C68.8718 77.8462 70.297 81.3355 73.1474 84.1859C75.9979 87.0363 79.4872 88.4615 83.6154 88.4615ZM51.3269 53.0769C47.1987 59.1709 45.1346 66.0513 45.1346 73.7179C45.1346 81.3846 47.1987 88.265 51.3269 94.359H4V77.9936C4 74.6517 4.83547 71.5555 6.50641 68.7051C8.17735 65.8547 10.4872 63.6923 13.4359 62.2179C18.4487 59.6624 24.1004 57.5 30.391 55.7308C36.6816 53.9615 43.6603 53.0769 51.3269 53.0769Z"
                  fill="#98999A"
                />
              </svg>
            </p>
            <FindAccountName>아이디 찾기</FindAccountName>
            <FindAccountDocs>
              가입 시 등록한 본인 명의 휴대폰으로
              <br />
              아이디 찾기가 가능합니다.
            </FindAccountDocs>
          </FindIdCard>
          <FindPwCard onClick={handleFindIdClick}>
            <p className="iconLogin iconPW">
              <svg xmlns="http://www.w3.org/2000/svg" width="108" height="123" viewBox="0 0 108 123" fill="none">
                <path
                  d="M30.2812 36.5909H61.8186V26.1364C61.8186 21.7803 60.2855 18.0777 57.2194 15.0284C54.1532 11.9792 50.4301 10.4545 46.0499 10.4545C41.6697 10.4545 37.9465 11.9792 34.8804 15.0284C31.8142 18.0777 30.2812 21.7803 30.2812 26.1364V36.5909ZM77.5873 115C70.3161 115 64.119 112.451 58.996 107.353C53.8729 102.254 51.3096 96.0912 51.3061 88.8636C51.3061 81.6326 53.8694 75.4696 58.996 70.3748C64.1225 65.2799 70.3196 62.7308 77.5873 62.7273C84.8584 62.7273 91.0572 65.2764 96.1838 70.3748C101.31 75.4731 103.872 81.6361 103.868 88.8636C103.868 96.0947 101.305 102.259 96.1786 107.358C91.052 112.456 84.8549 115.003 77.5873 115ZM47.3639 109.773H14.5125C11.6215 109.773 9.1476 108.75 7.09066 106.704C5.03372 104.659 4.0035 102.197 4 99.3182V47.0455C4 44.1705 5.03022 41.7102 7.09066 39.6645C9.15111 37.6189 11.625 36.5944 14.5125 36.5909H19.7687V26.1364C19.7687 18.9053 22.332 12.7423 27.4586 7.6475C32.5851 2.55265 38.7822 0.00348485 46.0499 0C53.321 0 59.5198 2.54917 64.6464 7.6475C69.773 12.7458 72.3345 18.9088 72.331 26.1364V36.5909H77.5873C80.4782 36.5909 82.9539 37.6155 85.0143 39.6645C87.0748 41.7136 88.1032 44.1739 88.0997 47.0455V53.8409C86.3476 53.2311 84.5956 52.8164 82.8435 52.5968C81.0914 52.3773 79.3393 52.2692 77.5873 52.2727C67.3376 52.2727 58.6438 55.8238 51.5058 62.9259C44.3679 70.028 40.7971 78.6739 40.7936 88.8636C40.7936 92.6098 41.3858 96.248 42.5702 99.7782C43.7546 103.308 45.3525 106.64 47.3639 109.773ZM77.5873 88.8636C79.7774 88.8636 81.6398 88.1022 83.1746 86.5793C84.7094 85.0564 85.4751 83.2042 85.4716 81.0227C85.4716 78.8447 84.7059 76.9942 83.1746 75.4714C81.6433 73.9485 79.7809 73.1853 77.5873 73.1818C75.3972 73.1818 73.5365 73.945 72.0051 75.4714C70.4738 76.9977 69.7064 78.8482 69.7029 81.0227C69.7029 83.2008 70.4703 85.0529 72.0051 86.5793C73.54 88.1057 75.4007 88.8671 77.5873 88.8636ZM77.5873 104.545C80.2154 104.545 82.6683 103.936 84.946 102.716C87.2237 101.496 89.1072 99.7973 90.5964 97.6193C88.5816 96.3996 86.479 95.5058 84.289 94.9377C82.0989 94.3697 79.865 94.0874 77.5873 94.0909C75.3096 94.0909 73.0757 94.3732 70.8856 94.9377C68.6955 95.5023 66.593 96.3961 64.5781 97.6193C66.0673 99.7973 67.9508 101.496 70.2285 102.716C72.5062 103.936 74.9591 104.545 77.5873 104.545Z"
                  fill="#98999A"
                />
              </svg>
            </p>
            <FindAccountName>비밀번호 찾기</FindAccountName>
            <FindAccountDocs>
              가입 시 등록한 본인 명의 휴대폰으로
              <br />
              비밀번호 찾기가 가능합니다.
            </FindAccountDocs>
          </FindPwCard>
        </CardWrap>
      </Inner>
    </Container>
  );
};
export default MobileFindAccount;
